import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CardTransactionsPage } from './card-transactions';

@NgModule({
  declarations: [
    CardTransactionsPage,
  ],
  imports: [
    IonicPageModule.forChild(CardTransactionsPage),
  ],
})
export class CardTransactionsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/card-transactions/card-transactions.module.ts